package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPolicyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("PrivacyPolicy.md", FrontMatterElement.Builder { addScalar("title", "Privacy Policy"); addScalar("subtitle", "プライバシーポリシー"); addScalar("description", "日本Kotlinユーザーグループ（以下，「当団体」といいます。）は，本イベントにおける，参加者の個人情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。…"); }))
}

@Page("/privacy-policy")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun PrivacyPolicyPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("日本Kotlinユーザーグループ（以下，「当団体」といいます。）は，本イベントにおける，参加者の個人情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第1条-個人情報") }) {
        org.jetbrains.compose.web.dom.Text("第1条（個人情報）")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，住所，電話番号，連絡先その他の記述等により特定の個人を識別できる情報及び容貌，指紋，声紋にかかるデータ，及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第2条-個人情報の収集方法") }) {
        org.jetbrains.compose.web.dom.Text("第2条（個人情報の収集方法）")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("当団体は，参加者が参加登録をする際に氏名，生年月日，住所，電話番号，メールアドレスなどの個人情報をお尋ねすることがあります。また，参加者と提携先などとの間でなされた参加者の個人情報を含む取引記録や決済に関する情報を，当団体の提携先（情報提供元，広告主，広告配信先などを含みます。以下，｢提携先｣といいます。）などから収集することがあります。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第3条-個人情報を収集-利用する目的") }) {
        org.jetbrains.compose.web.dom.Text("第3条（個人情報を収集・利用する目的）")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("当団体が個人情報を収集・利用する目的は，以下のとおりです。")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Kotlin Festの提供・運営のため")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("参加者からのお問い合わせに回答するため（本人確認を行うことを含む）")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Kotlin Festの更新情報等及び当団体が提供する他のイベントの案内のメールを送付するため")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("重要なお知らせなど必要に応じたご連絡のため")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("行動規範に違反した参加者や，不正・不当な目的で参加しようとする参加者の特定をし，ご参加をお断りするため")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("参加者にノベルティ・グッズ等の郵送を行うため")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("上記の利用目的に付随する目的")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第4条-利用目的の変更") }) {
        org.jetbrains.compose.web.dom.Text("第4条（利用目的の変更）")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体は，利用目的が変更前と関連性を有すると合理的に認められる場合に限り，個人情報の利用目的を変更するものとします。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("利用目的の変更を行った場合には，変更後の目的について，当団体所定の方法により，参加者に通知し，または本ウェブサイト上に公表するものとします。")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第5条-個人情報の第三者提供") }) {
        org.jetbrains.compose.web.dom.Text("第5条（個人情報の第三者提供）")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体は，次に掲げる場合を除いて，あらかじめ参加者の同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。")
            org.jetbrains.compose.web.dom.Ol {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("予め次の事項を告知あるいは公表し，かつ当団体が個人情報保護委員会に届出をしたとき")
                    org.jetbrains.compose.web.dom.Ol {
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("利用目的に第三者への提供を含むこと")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("第三者に提供されるデータの項目")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("第三者への提供の手段または方法")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("本人の求めに応じて個人情報の第三者への提供を停止すること")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("本人の求めを受け付ける方法")
                        }
                    }
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("前項の定めにかかわらず，次に掲げる場合には，当該情報の提供先は第三者に該当しないものとします。")
            org.jetbrains.compose.web.dom.Ol {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("当団体が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("合併その他の事由による事業の承継に伴って個人情報が提供される場合")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いた場合")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第6条-cookieに関するポリシー") }) {
        org.jetbrains.compose.web.dom.Text("第6条（Cookieに関するポリシー）")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("cookie-クッキー") }) {
        org.jetbrains.compose.web.dom.Text("Cookie（クッキー）")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Cookie（クッキー）は、利用者のサイト閲覧履歴を、利用者のコンピュータに保存しておく仕組みです。")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("利用者はCookie（クッキー）を無効にすることで収集を拒否することができますので、お使いのブラウザの設定をご確認ください。ただし、Cookie（クッキー）を拒否した場合、当サイトのいくつかのサービス・機能が正しく動作しない場合があります。")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("アクセス解析") }) {
        org.jetbrains.compose.web.dom.Text("アクセス解析")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("当サイトでは、サイトの分析と改善のためにGoogleが提供している「Google アナリティクス」を利用しています。")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("このサービスは、トラフィックデータの収集のためにCookie（クッキー）を使用しています。トラフィックデータは匿名で収集されており、個人を特定するものではありません。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第7条-個人情報の開示") }) {
        org.jetbrains.compose.web.dom.Text("第7条（個人情報の開示）")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。")
            org.jetbrains.compose.web.dom.Ol {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("当団体の業務の適正な実施に著しい支障を及ぼすおそれがある場合")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("その他法令に違反することとなる場合")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第8条-個人情報の訂正および削除") }) {
        org.jetbrains.compose.web.dom.Text("第8条（個人情報の訂正および削除）")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("参加者は，当団体の保有する自己の個人情報が誤った情報である場合には，当団体が定める手続きにより，当団体に対して個人情報の訂正，追加または削除（以下，「訂正等」といいます。）を請求することができます。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体は，参加者から前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正等を行うものとします。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体は，前項の規定に基づき訂正等を行った場合，または訂正等を行わない旨の決定をしたときは遅滞なく，これを参加者に通知します。")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第9条-個人情報の利用停止等") }) {
        org.jetbrains.compose.web.dom.Text("第9条（個人情報の利用停止等）")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行います。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("前項の調査結果に基づき，その請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の利用停止等を行います。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体は，前項の規定に基づき利用停止等を行った場合，または利用停止等を行わない旨の決定をしたときは，遅滞なく，これを参加者に通知します。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("前2項にかかわらず，利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって，参加者の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は，この代替策を講じるものとします。")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第10条-プライバシーポリシーの変更") }) {
        org.jetbrains.compose.web.dom.Text("第10条（プライバシーポリシーの変更）")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("本ポリシーの内容は，法令その他本ポリシーに別段の定めのある事項を除いて，参加者に通知することなく，変更することができるものとします。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体が別途定める場合を除いて，変更後のプライバシーポリシーは，本ウェブサイトに掲載したときから効力を生じるものとします。")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("第11条-お問い合わせ窓口") }) {
        org.jetbrains.compose.web.dom.Text("第11条（お問い合わせ窓口）")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("本ポリシーに関するお問い合わせは，下記の窓口までお願いいたします。")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("住所：〒110-0014 東京都台東区北上野2丁目8-4-501")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("団体名：日本Kotlinユーザーグループ")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("代表：日高 正博")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Eメールアドレス： ")
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@kotlinfest.dev") {
                org.jetbrains.compose.web.dom.Text("contact@kotlinfest.dev")
            }
        }
    }
}
